import React, { useEffect, useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import "./backdropBlur.css"
import { Button } from "reactstrap"

const SelectLitres = ({ onClose, driverData }) => {
  const [limitLitres, setLimitLitres] = useState("")
  const [distance, setDistance] = useState(0) // reward_distance
  const [fuel, setFuel] = useState(0) // reward_fuel
  const [loading, setLoading] = useState(true)
  const [kmsDeducted, setKmsDeducted] = useState(0)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken")
        const response = await axios.get(
          `${process.env.REACT_APP_WEB_APP_URL}/api/web/reward-settings`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status === 200) {
          const { reward_distance, reward_fuel } = response.data.data
          setDistance(Number(reward_distance))
          setFuel(Number(reward_fuel))
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  // Calculate kms deduction when litres change
  useEffect(() => {
    if (fuel > 0 && distance > 0 && limitLitres) {
      const ratio = distance / fuel // kms per litre
      setKmsDeducted(limitLitres * ratio)
    } else {
      setKmsDeducted(0)
    }
  }, [limitLitres, fuel, distance])

  const handleChange = e => {
    const value = e.target.value
    if (!value || isNaN(value)) {
      setLimitLitres("")
      return
    }
    if (Number(value) <= driverData.total_fuel_since_last_reward) {
      setLimitLitres(Number(value))
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!limitLitres) return
    setSubmitting(true)
    try {
      const token = localStorage.getItem("authToken")
      const formData = new FormData()
      formData.append("driver_id", Number(driverData.user_id))
      formData.append("limit_liters", Number(limitLitres))

      const response = await axios.post(
        `${process.env.REACT_APP_WEB_APP_URL}/api/web/reward/refill`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.status === 200) {
        toast.success("Reward redeemed successfully!")
        onClose()
      }
    } catch (err) {
      console.error(err)
      toast.error("Failed to redeem reward")
    } finally {
      setSubmitting(false)
    }
  }

  // Loader while fetching
  if (loading) {
    return (
      <div className="backdrop d-flex justify-content-center align-items-center">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <>
      {/* Custom backdrop with blur */}
      <div className="backdrop">
        <div className="modal show fade d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <h5 className="modal-title">Select Litres</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>

              {/* Body */}
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">
                      Available Fuel Since Last Reward:
                    </label>
                    <p className="fw-bold">
                      {driverData.total_fuel_since_last_reward} litres
                    </p>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Enter Limit Litres:</label>
                    <input
                      type="number"
                      value={limitLitres}
                      onChange={handleChange}
                      className="form-control"
                      min="1"
                      max={driverData.total_fuel_since_last_reward}
                      required
                    />
                    <div className="form-text">
                      Max: {driverData.total_fuel_since_last_reward} litres
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Kms:</label>
                    <p className="fw-bold">{kmsDeducted.toFixed(2)} kms</p>
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                  >
                    Close
                  </button>
                  <Button
                    color="success"
                    type="submit"
                    disabled={submitting || !limitLitres}
                  >
                    {submitting ? "Processing..." : "Redeem"}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SelectLitres
